import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
    PaperProps
} from "@mui/material";
import { useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import ApiResources from "src/providers/ApiResources";
import Draggable from 'react-draggable';

interface ReindexRouteModalProps {
    open: boolean;
    setOpen: any;
}

const PaperComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}
  
export const ReindexRouteModal = (props: ReindexRouteModalProps) => {
    const { open, setOpen } = props;

    const [loading, setLoading] = useState(false);
    const [submitError, setSubmitError] = useState(null);
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const executeCommand = async () => {
        try {
            setLoading(true);
            setSubmitError(null);
            dataProvider
            .create(ApiResources.postCmdReindexRoute(false), {
                data: {}
            })
            .then((res) => {
                notify(`Reindexing route process completed.`, { type: 'success' });
                setLoading(false);
                setOpen(false);
            })
            .catch((error) => {
                notify(error.message, { type: 'error' });
                setSubmitError(error.message);
                setLoading(false);
            });
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <Dialog
            onClose={() => setOpen(false)}
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="sm"
        >
            <DialogTitle sx={{padding: "18px"}}>
                <Typography variant="body1" sx={{fontSize: "20px", fontWeight: "500"}}>Reindex Route</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{padding: "18px !important"}}>
                <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12} md={12}>
                        <Typography variant="subtitle1">Are you sure you want to execute this command?</Typography>
                    </Grid>

                    { submitError &&
                    <Grid item sm={12} md={12} sx={{display: "flex", marginTop: "18px"}}>
                        <Typography variant="subtitle2" color="error">{submitError}</Typography>
                    </Grid>                     
                    } 
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "18px"}}>
                <Button
                    variant="outlined"
                    onClick={() => {
                    setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    disabled={loading} 
                    onClick={() => executeCommand()}
                >
                    {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff", marginRight: "8px"}}/>}
                    Execute Command
                </Button>
            </DialogActions>
        </Dialog>
    );
};
